export default __webpack_public_path__ + "static/media/green-grid.7411071c.svg";